//pages
export const BASICDETAIL1_LANDING_PAGE = 1;
export const BASICDETAIL2_LANDING_PAGE = 2;
export const BASICDETAIL3_LANDING_PAGE = 3;
export const KYC_LANDING_PAGE = 4;
export const LOAN_CONFIRMATION_LANDING_PAGE = 5;
export const SELECT_EMI_LANDING_PAGE = 6;
export const LCM_AGREEMENT_LANDING_PAGE = 7;
export const BANK_DETAIL_LANDING_PAGE = 8;
export const BANK_DETAIL_ENACH_LANDING_PAGE = 9;
export const TERMCONDITION_LANDING_PAGE = 10;

export const TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjdXN0b21lcl9pZCI6MzQ4OTQzMDA4LCJleHAiOjE2NTQ4NzQ1NTJ9.qY59h60lVxfaErq1J43yLRk_7nCleSw4Lbuy8DIrif0'
